import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useShallowSidebarStore } from "../store/sidebar-store";
import { ContactDetailsSection } from "../components/SidebarPanel";
import { AvatarWithPicture } from "../components/AvatarWithPicture";
import { toast } from "sonner";

export interface EnduserNotificationProps {
  message: string;
  enduser: TellescopeModelFromName<"endusers">;
  relatedEnduserId: string;
  enduserSubsection?: ContactDetailsSection;
  toastId?: string | number;
}

export const EnduserNotification = ({
  message,
  enduser,
  relatedEnduserId,
  enduserSubsection = "Timeline",
  toastId,
}: EnduserNotificationProps) => {
  const { openSidebar } = useShallowSidebarStore("openSidebar");

  return (
    <div
      role="button"
      className="flex gap-3 items-center cursor-pointer hover:bg-accent p-4 rounded-lg bg-background border border-border shadow-lg transition-colors min-w-[320px]"
      onClick={() => {
        if (toastId !== undefined) {
          toast.dismiss(toastId);
        }
        openSidebar("ContactDetails", {
          enduserId: relatedEnduserId,
          selectedSection: enduserSubsection,
        });
      }}
    >
      <AvatarWithPicture avatarLike={enduser} />
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <p className="font-semibold text-sm truncate">{message}</p>
      </div>
    </div>
  );
};
